module.exports = __webpack_public_path__ + "img/myguard_about_04.baaf8d8f.png";